import type { DraftPresentation } from '../../contracts/approval-kinds';

/** The text an edit would leave, attached by the backend to a Work edit approval. */
export interface TextEditPreview {
  before: string;
  after: string;
}

const readBeforeAfter = (raw: unknown): TextEditPreview | null => {
  if (!raw || typeof raw !== 'object') return null;
  const { before, after } = raw as Record<string, unknown>;
  if (typeof before !== 'string' || typeof after !== 'string') return null;
  return { before, after };
};

/**
 * `context.presentation[target]`, else `context.approval_preview` of kind
 * `text_edit`, or `null`. The backend keys an edit's text by its draft target.
 */
export const readTextEditPreview = (
  context: Record<string, unknown> | undefined,
  target: DraftPresentation['target'] | undefined
): TextEditPreview | null => {
  const presentation = context?.presentation;
  const keyed =
    target && presentation && typeof presentation === 'object'
      ? readBeforeAfter((presentation as Record<string, unknown>)[target])
      : null;
  if (keyed) return keyed;
  // TODO: drop once no pending approval predates `presentation` (ml-scribe 1.95.0 sends only this).
  const legacy = context?.approval_preview;
  if (!legacy || typeof legacy !== 'object') return null;
  if ((legacy as Record<string, unknown>).kind !== 'text_edit') return null;
  return readBeforeAfter(legacy);
};
